import React from "react";
import { Card, Row, Col, Typography, Button } from "antd";
import { DatabaseOutlined, DiffOutlined, ShareAltOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const { Title, Paragraph } = Typography;

const SalesforceToolsDashboard = () => {

    const navigate=useNavigate();
  return (
    <div style={{ padding: 24 }}>
      <Title level={2} style={{ textAlign: "center", marginBottom: 24 }}>
        Welcome to Salesforce Tools
      </Title>
      <Paragraph style={{ textAlign: "center", marginBottom: 40 }}>
        Manage your Salesforce orgs efficiently, compare data across environments, and handle
        migrations with ease. Choose a tool from the tabs above to get started.
      </Paragraph>

      <Row gutter={[24, 24]} justify="center">
        <Col xs={24} sm={12} md={8}>
          <Card
            hoverable
            style={{ textAlign: "center" }}
            icon={<DatabaseOutlined style={{ fontSize: 36, color: "#1890ff" }} />}
            title="Org Connections"
          >
            <Paragraph>
              Connect your Salesforce orgs securely and manage multiple environments effortlessly.
            </Paragraph>
            <Button type="primary" onClick={()=>navigate('/SalesforceTools/Connections')}>Go to Connections</Button>
          </Card>
        </Col>

        <Col xs={24} sm={12} md={8}>
          <Card
            hoverable
            style={{ textAlign: "center" }}
            icon={<DiffOutlined style={{ fontSize: 36, color: "#52c41a" }} />}
            title="DiffInsight"
          >
            <Paragraph>
              Compare data between two Salesforce orgs and get insightful differences in seconds.
            </Paragraph>
            <Button type="primary" onClick={()=>navigate('/SalesforceTools/DiffInsight')}>Go to DiffInsight</Button>
          </Card>
        </Col>

        <Col xs={24} sm={12} md={8}>
          <Card
            hoverable
            style={{ textAlign: "center" }}
            icon={<ShareAltOutlined style={{ fontSize: 36, color: "#faad14" }} />}
            title="RCA Migration Tool"
          >
            <Paragraph>
              Handle metadata and configuration migrations across orgs with confidence.
            </Paragraph>
            <Button type="primary" onClick={()=>navigate('/SalesforceTools/RCAMigration')}>Go to RCA Migration</Button>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default SalesforceToolsDashboard;
